import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { userReplacementStatus } from "../containers/Admin/UserReplacement/helpers";

const TAG_TYPES = {
  userReplacementSearch: "UserReplacementSearch",
};

export const userReplacementApi = createApi({
  reducerPath: "userReplacementApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "userReplacement",
  }),
  tagTypes: [TAG_TYPES.userReplacementSearch],
  endpoints: (build) => ({
    userReplacementSearch: build.query({
      query: (queryParams) => appendQueryParameters("search", queryParams),
      transformResponse: ({ data }) => data,
      providesTags: [TAG_TYPES.userReplacementSearch],
    }),
    projectNumberSuggest: build.query({
      query: ({ projectNumber, userId }) =>
        `projectNumber/${projectNumber}?userId=${userId || ""}`,
      transformResponse: ({ data }) => data,
    }),
    submitUserReplace: build.mutation({
      query: ({ userReplaceRequest, queryParams, data }) => ({
        url: "submit",
        method: "POST",
        body: userReplaceRequest,
      }),
      async onQueryStarted(
        { userReplaceRequest, queryParams, data },
        { dispatch, queryFulfilled }
      ) {
        try {
          await queryFulfilled;
          const selectedRowKeys = userReplaceRequest.projectUserRoles.map(
            ({ id }) => id
          );
          const updateData = data.map((row) => {
            if (selectedRowKeys.includes(row.id)) {
              return { ...row, status: userReplacementStatus.pending };
            }
            return row;
          });
          dispatch(
            userReplacementApi.util.updateQueryData(
              "userReplacementSearch",
              queryParams,
              () => updateData
            )
          );
        } catch {
          console.error("error processing user replacement requests.");
        }
      },
    }),
  }),
});

export const {
  useUserReplacementSearchQuery,
  useProjectNumberSuggestQuery,
  useSubmitUserReplaceMutation,
} = userReplacementApi;
